export function isIosDevice() {
    return ([
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
    ].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes("Mac") && "ontouchend" in document));
}
export function isAndroidDevice() {
    return /android/i.test(navigator.userAgent);
}
//# sourceMappingURL=compatibility.js.map